<template>
    <div class="or-admin-news-title flex-row">
        <p class="title">{{title}}</p>
        <p class="delete hover-pointer hover-red" @click="$emit('remove')">Удалить</p>
        <p class="move hover-pointer hover-yellow" @click="$emit('up')">Выше</p>
        <p class="move hover-pointer hover-yellow" @click="$emit('down')">Ниже</p>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
    }
}
</script>

<style scoped>
    .or-admin-news-title {
        font-size: 14px;
        line-height: 16px;
    }
    .title {
        font-weight: bold;
        color: #000000;
    }
    .delete {
        font-weight: normal;
        color: #b5b5b5;
        margin-left: 15px;
    }
    .edit {
        font-weight: normal;
        color: #b5b5b5;
        margin-left: 15px;
    }
    .move {
        font-weight: normal;
        color: #b5b5b5;
        margin-left: 15px;
    }
</style>